<template>
  <div>
    <div class="welcome-container row mb-3">
      <div class="col-12 title">اتفاقيات مزود الخدمة</div>
      <div class="col-12 sub-title">هل ترغب بإضافة مزود خدمة؟</div>
      <!-- the previous request's service providers were not usable for pre-fill -->
      <div v-if="prefill_sp_dropped" class="col-12 error-message mt-2">
        تعذر استرجاع اتفاقيات مزود الخدمة من الطلب السابق، يرجى إدخالها مرة أخرى
      </div>
    </div>
    <form class="form-step1 w-100">
      <div
        class="d-flex align-items-center mb-3 pb-3"
        style="border-bottom: 1px solid #dadada"
      >
        <div style="margin-left: 1rem">
          <RadioButton
            inputId="rb1"
            name="flag"
            value="yes"
            v-model="payload.flag"
            :class="[
              {
                'p-invalid': submitted && !payload.flag ? true : false,
              },
            ]"
            @click="
              () => {
                payload.service_provider = [
                  { hospital_id: null, discount: null, agreement_attachment: null },
                ];
                submitted = false;
              }
            "
          />
          <label for="rb1" style="margin-right: 0.5rem">نعم</label>
        </div>

        <div>
          <RadioButton
            inputId="rb2"
            name="flag"
            value="no"
            v-model="payload.flag"
            :class="[
              {
                'p-invalid': submitted && !payload.flag ? true : false,
              },
            ]"
            @click="
              () => {
                payload.service_provider = null;
                submitted = false;
              }
            "
          />
          <label for="rb2" style="margin-right: 0.5rem">لا</label>
        </div>
      </div>

      <div v-if="payload.flag === 'yes'">
        <div
          v-for="(e, i) in payload.service_provider"
          :key="i"
          :style="
            i < payload.service_provider.length - 1
              ? 'border-bottom: 1px solid #dadada'
              : ''
          "
        >
          <div
            class="remove-link mb-2 mt-2"
            v-if="payload.service_provider.length > 1"
            @click.stop="remove(i)"
          >
            - إلغاء
          </div>
          <div class="row align-items-end">
            <div class="col-md-3 custom-form-group">
              <Dropdown
                optionLabel="name"
                optionValue="id"
                v-model="e.hospital_id"
                :disabled="loading"
                :class="[
                  'w-100',
                  {
                    'p-invalid': submitted && !e.hospital_id ? true : false,
                  },
                ]"
                :options="getOptions(e)"
                :filter="true"
                :filterby="name"
                placeholder="اسم المستشفى"
              />
            </div>
            <div class="col-md-3 custom-form-group">
              <div class="form-label-group" style="position: relative">
                <div>
                  <span class="p-float-label">
                    <InputText
                      id="discount"
                      type="number"
                      v-model="e.discount"
                      :min="0"
                      :max="100"
                      :disabled="loading"
                      :class="[
                        'w-100',
                        {
                          'p-invalid':
                            submitted &&
                            (!e.discount || !(e.discount >= 0 && e.discount <= 100))
                              ? true
                              : false,
                        },
                      ]"
                      style="padding-right: 60px"
                    />
                    <label for="discount" style="padding-right: 50px">
                      نسبة الخصم
                    </label>
                  </span>
                </div>
                <div
                  class="percentage-block d-flex align-items-center justify-content-center"
                >
                  %
                </div>
              </div>
            </div>
            <div class="col-md-6 custom-form-group">
              <div class="w-100">
                <label class="association-label">اتفاقيات مزودي الخدمة المستشفيات</label>
                <div v-if="!e.agreement_attachment" class="mt-2">
                <span
                    class="attachment-container"
                    @click.stop="$refs[`agreement_attachment_${i}`][0].$el.click()"
                >
                  <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
                  <span class="label">إرفاق المستند</span>
                </span>
                </div>
                <div v-else class="mt-2">
                  <div
                      class="association-logo d-flex flex-wrap align-items-center justify-content-between file"
                  >
                    <div class="d-flex align-items-center upload-wrapper">
                      <div class="logo-name w-100">
                        <div class="text-truncate">
                          {{ e.agreement_attachment.name }}
                        </div>
                        <div>
                          {{ getbytes(e.agreement_attachment.size) }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex align-items-center">
                     <button
                       class="btn btn-lg btn-block cancel-btn"
                       type="button"
                       @click.stop="$refs[`agreement_attachment_${i}`][0].$el.click()"
                     >
                       <img :src="`${staticUrl}/static/images/attachment.png`" alt="attachment" />
                       تعديل
                     </button>
                     <button
                       class="btn btn-lg btn-block cancel-btn me-1"
                       @click="$emit('removeFileFromProvider', i)"
                     >
                       إلغاء
                     </button>
                   </div>
                  </div>
                </div>
                <InputText
                  :ref="`agreement_attachment_${i}`"
                  class="d-none"
                  type="file"
                  accept="application/pdf"
                  @change="(event) => handleFileChange(event, i)"
                />
                <div v-if="attachment_errors[i]" class="error-message p-invalid mt-2">
                  {{ attachment_errors[i] }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="add-link d-flex align-items-center justify-content-center"
          @click.stop="add"
        >
          <div><img :src="`${staticUrl}/static/images/plus.png`" alt="plus" /></div>
          <div class="label">إضافة مزود خدمة جديد</div>
        </div>
        <div class="border-container"></div>
      </div>
    </form>
    <div class="row">
      <div class="col-lg-6">
        <button
          id="close-btn"
          class="btn btn-lg btn-secondary btn-block close-btn"
          type="button"
          @click.stop="$emit('close')"
        >
          السابق
        </button>
      </div>
      <div class="col-lg-6">
        <button
          id="tracking-btn"
          class="btn btn-lg btn-primary btn-block tracking-btn"
          type="button"
          :disabled="loadingServiceProvider"
          @click.stop="submit"
        >
          <span v-if="loadingServiceProvider" class="spinner-border spinner-border-sm mx-1"></span>
          متابعة
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from "primevue/radiobutton";
import Dropdown from "primevue/dropdown";
import { addStepToCharity, isFileSizeValid, MAX_FILE_SIZE_ERROR_MESSAGE } from "@/helpers/helpers";
import EnumService from "../../../services/enum.service";

export default {
  name: "create-account-step5",
  inject: ['staticUrl'],
  props: ["payload","apierrors","prefill_sp_dropped"],
  emits: [
     "close",
     "next",
     "addServiceProvider",
     "removeServiceProvider",
     "setPayload",
     "fileChangeInProvider",
     "removeFileFromProvider"
   ],
  components: { RadioButton, Dropdown },
  data() {
    return {
      loading: false,
      error: null,
      submitted: false,
      options: [],
      loadingServiceProvider: false,
      initialData: JSON.stringify(this.payload.service_provider),
      attachment_errors: []
    };
  },
  methods: {
    getbytes(data) {
      if (!data) return "";
      const const_term = 1024;
      let KB, MB, GB, TB;

      KB = (data / const_term).toFixed(3);
      MB = (data / const_term ** 2).toFixed(3);
      GB = (data / const_term ** 3).toFixed(3);
      TB = (data / const_term ** 4).toFixed(3);

      if (TB > 0) {
        return TB + "TB";
      } else if (GB > 0) {
        return GB + "GB";
      } else if (MB > 0) {
        return MB + "MB";
      } else if (KB > 0) {
        return KB + "KB";
      }
      return data + "B";
    },
    getOptions(e) {
      return this.options.filter((rec) => {
        if (rec && rec.id) {
          const rec_found = this.payload.service_provider.find((s_p_rec) => {
            return (
              s_p_rec &&
              s_p_rec.hospital_id &&
              (!e.hospital_id ||
                (e.hospital_id && s_p_rec.hospital_id !== e.hospital_id)) &&
              s_p_rec.hospital_id === rec.id
            );
          });
          return !rec_found;
        } else {
          return false;
        }
      });
    },
    submit() {
      this.submitted = true;
      const buggy_records =
        this.payload.service_provider && this.payload.service_provider.length
          ? this.payload.service_provider.filter(
            (each) =>
              !(
                each.hospital_id &&
                each.discount &&
                each.discount >= 0 &&
                each.discount <= 100
              )
          )
          : [];

      if (
        (this.payload.flag === "yes" && !buggy_records.length) ||
        this.payload.flag === "no"
      ) {
          this.initialData !== JSON.stringify(this.payload.service_provider) ?  this.sendServiceProvider() : this.$emit("next");
      }
    },
    handleFileChange(event, index) {
      const file = event.target.files[0];
      if (!file) return;
      const is_pdf = file.name.toLowerCase().endsWith('.pdf');

      if (!is_pdf) {
        event.target.value = '';
        this.attachment_errors[index] = 'الرجاء تحميل ملف بصيغة PDF فقط.';
        return;
      }
      if (!isFileSizeValid(file)) {
        event.target.value = '';
        this.attachment_errors[index] = MAX_FILE_SIZE_ERROR_MESSAGE;
        return;
      }
      this.attachment_errors[index] = null;
      this.$emit('fileChangeInProvider', event, index);
    },
    add() {
      this.$emit("addServiceProvider");
    },
    remove(index) {
      this.$emit("removeServiceProvider", index);
    },
    enum_hospitals() {
      this.loading = true;
      this.error = null;

      EnumService.hospitals()
        .then(({ data }) => {
          if (data.result.length) this.options = data.result;
        })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async sendServiceProvider() {
       this.loadingServiceProvider = true;
       this.error = null;
       let serviceProvidersForStorage = [];
 
       if (this.payload.flag === 'yes' && this.payload.service_provider?.length) {
      serviceProvidersForStorage = this.payload.service_provider.map(provider => {
           const providerCopy = { ...provider };
           if (providerCopy.agreement_attachment) {
          providerCopy.agreement_attachment = providerCopy.agreement_attachment;
        }
      return providerCopy;
    });
  }
       const SpPayload = {
         number_of_service_provider_agreements: serviceProvidersForStorage.length,
         service_provider: serviceProvidersForStorage,
       };
       if (this.payload.flag === "no") {
         SpPayload.number_of_service_provider_agreements = 0;
         SpPayload.service_provider = [];
       }
 
       addStepToCharity("step5", SpPayload);

       this.$emit("setPayload", "number_of_service_provider_agreements", SpPayload.number_of_service_provider_agreements);
       this.$emit("setPayload", "service_provider", SpPayload.service_provider);
 
       this.loadingServiceProvider = false;
       this.$emit("next");
     },
  },
  mounted() {
    this.enum_hospitals();
    this.payload.number_of_service_provider_agreements ? this.payload.flag = 'yes' : this.payload.flag = 'no';
  },
  watch: {
    'payload.service_provider': {
      handler(newVal) {
        if (newVal && newVal.length !== this.attachment_errors.length) {
          this.attachment_errors = Array(newVal.length).fill(false);
        }
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.welcome-container {
  .title {
    font-size: 24px;
    font-weight: bold;
  }
  .sub-title {
    font-size: 18px;
  }
}
.error-message {
  color: $color-red-darker;
  font-size: 14px;
}
.border-container {
  border-top: 1px solid #dadada;
  padding-top: 2rem;
  margin-top: 2rem;
}
.add-link {
  cursor: pointer;
  .label {
    margin-right: 0.5rem;
    color: #12b2aa;
  }
}
.percentage-block {
  position: absolute;
  font-size: 18px;
  top: 0px;
  right: 0px;
  height: 50px;
  width: 50px;
  border-radius: 0px 5px 5px 0px;
  background: #d9d9d9;
}

.remove-link {
  cursor: pointer;
  text-align: right;
  font-size: 18px;
  color: #12b2aa;
}
.tracking-btn {
  display: block;
  margin: 0 auto;
  width: 80%;
  border-radius: 25px;
  padding: 10px;
  background: #12b2aa;
  color: #ffffff;
  border: none;
  font-size: 18px;
}

.tracking-btn:hover {
  background-color: #0e8e88 !important;
  border: none;
}

.close-btn {
  display: block;
  margin: 0 auto;
  width: 80%;
  border-radius: 25px;
  padding: 10px;
  background: #d9d9d9;
  color: #3f3f3f;
  border: none;
  font-size: 18px;
}

.attachment-container {
  cursor: pointer;
  background-color: #d9d9d9;
  border-radius: 25px;
  padding: 0.5rem 1rem;
  display: inline-block;

  .label {
    color: #3f3f3f;
    font-size: 18px;
    font-weight: 500;
    margin-right: 0.5rem;
  }
}

.association-logo {
  height: 80px;
  border-radius: 5px;
  border: 1px dashed #d9d9d9;
  padding: 10px 20px;
  .logo-name {
    color: #8c8c8c;
    font-size: 14px;
  }
  .upload-wrapper {
    width: 50%;
  }
}

.association-label {
  font-size: 14px;
  font-weight: bold;
  display: block;
}

.cancel-btn {
  border-radius: 25px;
  font-size: 14px;
  background-color: #d9d9d9;
  color: #3f3f3f;
  border: none;
}

.cancel-btn:hover {
  background-color: #b2b2b2;
  color: #3f3f3f;
}

.custom-form-group {
  margin-bottom: 1rem;
}
</style>
